import Fuse from "fuse.js";
import {highlight} from "./Highlight";

const resetOptions = (options) => {
    options.map(option => {
        option.classList.remove('hidden');

        option.querySelectorAll('.summary span').forEach((highlight) => {
            highlight.parentNode.replaceChild(document.createTextNode(highlight.textContent), highlight);
        });
    });
};

const buildSearchIndex = (options) => {
    const index = options.map((option) => {
        return {
            title: option.querySelector('h4').textContent.trim(),
            description: option.querySelector('p').textContent.trim(),
            category: option.querySelector('.category').textContent.trim(),
        };
    });

    return new Fuse(index, {
        keys: ['title', 'description', 'category'],
        threshold: 0.2,
        findAllMatches: true,
        ignoreLocation: true,
    });
};

const highlightSearchResults = (option, value) => {
    highlight(option.querySelector('h4'), value);
    highlight(option.querySelector('p'), value);
};

const updateResultCount = (selector, options) => {
    const visibleCount = options.filter(option => !option.classList.contains('hidden')).length;

    selector.querySelector('.count').textContent = selector.dataset.countTemplate
        .replace('%d', visibleCount)
        .replace('%d', options.length)
    ;

    selector.querySelector('.no-results').hidden = visibleCount !== 0;
};

const search = (searchIndex, value, options, selector) => {
    resetOptions(options);

    if (value.trim() === '') {
        updateResultCount(selector, options);

        return;
    }

    const searchResults = searchIndex.search(value).map(hit => hit.refIndex);

    options.forEach((option, optionIndex) => {
        if (searchResults.indexOf(optionIndex) !== -1) {
            highlightSearchResults(option, value);

            return;
        }

        option.classList.add('hidden');
        option.classList.remove('selected');
    });

    updateResultCount(selector, options);
};

export const Search = (selector) => {
    const options = Array.from(selector.querySelectorAll('li'));

    const searchIndex = buildSearchIndex(options);

    return {
        search: (value) => search(searchIndex, value, options, selector),
    };
};
